<template>
  <b-img
    v-if="white"
    key="white"
    class="company-logo"
    src="@/assets/samsung_wordmark_white.png"
  />
  <b-img
    v-else
    key="blue"
    class="company-logo"
    src="@/assets/samsung_wordmark.svg"
  />
</template>

<script>
export default {
  props: {
    white: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
